import React from 'react'

import './assets/scss/styles.scss'
import './utils/i18n/i18n'
import { ConfigProvider } from 'antd'

import inputConfig from './configs/theme-tokens'
import { AppRoutes } from './routing'

function App() {
  return (
    <ConfigProvider theme={inputConfig}>
      <AppRoutes />
    </ConfigProvider>
  )
}

export default App
